import { InstructionApiInterface } from '@navvis/ivion';

export enum RoutePointType {
  From = 0,
  To = 1,
}

export interface RouteDefinition {
  type: RoutePointType;
  position: { x: number; y: number; z: number };
  name: string;
  isPoi: boolean;
}

export interface RouteInstructionVm {
  originalInstruction: InstructionApiInterface;
  type: string;
  floor: string | null;
  buildingName: string | null;
  position: { lon: number; lat: number; z: number };
  name: string;
}
